var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 6.50508H21M4.01099 2.50004V2C4.01099 1.72386 4.23484 1.5 4.51099 1.5H17.4878C17.7639 1.5 17.9878 1.72386 17.9878 2V2.50004M4.98834 9.00006H5.03295M4.96603 12.1079H5.01064M4.94379 15.2158H4.9884M9.03296 9.00006H9.07757M9.01065 12.1079H9.05526M8.98834 15.2158H9.03295M13.0776 9.00006H13.1222M13.0553 12.1079H13.0999M13.033 15.2158H13.0776M17.1222 9.00006H17.1668M17.0999 12.1079H17.1445M17.0776 15.2158H17.1222M3 18.5H19C20.1046 18.5 21 17.6046 21 16.5V4.5C21 3.39543 20.1046 2.5 19 2.5H3C1.89543 2.5 1 3.39543 1 4.5V16.5C1 17.6046 1.89543 18.5 3 18.5Z",
    stroke: "#64636399",
    strokeOpacity: 0.6,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.a0a48e9407ae31e013f2cfe0583e2a7b.svg";
export { ForwardRef as ReactComponent };